import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import Tile4Wrapper from './Links';
import StandardTiles from './StandardTiles/StandardTiles';
import type { Tile4variants, Tiles4Props } from './types';
const components = {
  Standard: StandardTiles,
  Links: Tile4Wrapper
} as Record<Tile4variants, ComponentType<Tiles4Props>>;
export default function Tiles4(props) {
  const $ = _c(3);
  const Component = components[props.variant] ?? "div";
  let t0;
  if ($[0] !== Component || $[1] !== props) {
    t0 = <Component {...props} />;
    $[0] = Component;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}